import { Button, ButtonGroup, Modal } from "@datapay-by-datacom/design-system";
import { Heading } from "react-aria-components";
import s from "./ReplaceCompanyCsvConfirmModal.module.css";

export interface ReplaceCompanyCsvConfirmModalProps {
  isOpen: boolean;
  companyCount: number;
  fileName: string;
  onCancel: () => void;
  onReplace: () => void;
}

/**
 * Protects parsed and edited company data from being replaced accidentally
 * when a second CSV is selected.
 */
export function ReplaceCompanyCsvConfirmModal({
  isOpen,
  companyCount,
  fileName,
  onCancel,
  onReplace,
}: ReplaceCompanyCsvConfirmModalProps) {
  const companyLabel = companyCount === 1 ? "company" : "companies";

  return (
    <Modal isOpen={isOpen}>
      <div className={s.modalContent}>
        <Heading slot="title" className={s.title}>
          Replace uploaded companies?
        </Heading>
        <p className={s.message}>
          Uploading <strong>{fileName}</strong> will replace the{" "}
          <strong>
            {companyCount} parsed {companyLabel}
          </strong>
          , including any edits and validation results.
        </p>
        <p className={s.warning}>
          The current companies will be removed before the new file is
          processed. They will not be restored if the new file cannot be
          imported.
        </p>
        <div className={s.actions}>
          <ButtonGroup>
            <Button variant="primary" onPress={onCancel}>
              Keep current companies
            </Button>
            <Button variant="tertiary" onPress={onReplace}>
              Replace companies
            </Button>
          </ButtonGroup>
        </div>
      </div>
    </Modal>
  );
}
